import { TimePicker, TimePickerProps } from "@mui/x-date-pickers/TimePicker";

export type { TimePickerProps };
export default TimePicker;
